module.exports = __webpack_public_path__ + "img/lamisil.e6bea3ed.jpg";